let pair_routes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    children: [
      { path: 'pairs', name: 'pairs.list', component: () => import('./pages/Index.vue') },
      { path: 'pairs/create', name: 'pairs.create', component: () => import('./pages/Create.vue') },
      { path: 'pairs/:id/edit', name: 'pairs.edit', component: () => import('./pages/Edit.vue') }
    ]
  }
];

export default pair_routes;
